import { Download as ExportIcon } from '@tunasong/icons'
import type { Command, GenerateEntityCommand } from '@tunasong/plugin-lib'
import { features, workflowsApi } from '@tunasong/redux'
import type { ExportWorkflowOutput } from '@tunasong/redux'
import { z } from 'zod'
import { exportsRoute } from './exports-route.js'

const exportableTypes = ['bandspace', 'folder'] as const

/** Copy shared with the Exports page picker (PR #1858) */
export const exportDescription =
  'Exports everything inside it — songs, chords, audio and images — as a zip a local Tunasong opens directly.'

const isRunningFor = (rootEntityId: string, executions: ExportWorkflowOutput[] | undefined) =>
  (executions ?? []).some(e => e.rootEntityId === rootEntityId && e.status === 'RUNNING')

/**
 * "Export this space…" on a bandspace or folder. The entity IS the root, so there is no picker;
 * the framework's parameter prompt (an empty schema) is the confirmation.
 */
export const getExportSpaceCommands = ({ entity, globalContext }: GenerateEntityCommand): Command[] => {
  if (!entity || !exportableTypes.some(type => type === entity.type)) {
    return []
  }
  const { dispatch, getState } = globalContext
  const executions = workflowsApi.endpoints.getExports.select(undefined)(getState()).data
  const running = isRunningFor(entity.id, executions)

  return [
    {
      id: 'export-space',
      name: 'Export this space…',
      groupId: 'entity-actions',
      Icon: ExportIcon,
      blockOnRun: false,
      cmdParamsSchema: z.object({}),
      cmdPrompt: { title: `Export ${entity.name}`, description: exportDescription, confirmLabel: 'Export' },
      cmd: running
        ? null
        : async () => {
            await dispatch(workflowsApi.endpoints.export.initiate({ rootEntityId: entity.id })).unwrap()
            dispatch(
              features.notifications.actions.setAlert({
                severity: 'info',
                message: 'Preparing your export. It will be ready in Profile › Exports.',
                link: exportsRoute,
              })
            )
          },
    },
  ]
}
